const pendingTestimonials = [
  {
    title: 'Former client note',
    body: 'Reserved for a permissioned quote on close rhythm, cash clarity, finance operations, or systems cleanup.',
  },
  {
    title: 'Colleague note',
    body: 'Reserved for a public read on judgment, reliability, operator presence, and how I work under real pressure.',
  },
  {
    title: 'Collaborator note',
    body: 'Reserved for people who have built, shipped, mapped, or untangled systems with me.',
  },
];

export function TestimonialQueue() {
  return (
    <section id="testimonials" data-guide-label="Testimonials" className="border-b border-ink/5 bg-paper">
      <div className="mx-auto max-w-5xl px-6 py-20">
        <div className="max-w-3xl">
          <p className="font-display text-xs uppercase tracking-[0.25em] text-accent">
            Testimonials in progress
          </p>
          <h2 className="mt-3 font-display text-3xl tracking-tight md:text-4xl">
            Public words are being requested.
          </h2>
          <p className="mt-4 text-ink/70">
            I am asking former clients, colleagues, and collaborators for
            permissioned notes. Until each person approves the wording and
            attribution, this space stays intentionally empty.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {pendingTestimonials.map((item) => (
            <article key={item.title} className="rounded-sm border border-accent/25 bg-white p-6">
              <p className="font-display text-xs uppercase tracking-[0.2em] text-accent">
                Coming soon
              </p>
              <h3 className="mt-4 font-display text-xl tracking-tight">{item.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-ink/65">{item.body}</p>
            </article>
          ))}
        </div>

        <p className="mt-8 max-w-2xl text-sm italic text-ink/55">
          Public-safe only: no names, companies, private records, screenshots,
          or engagement details appear here without explicit approval.
        </p>
      </div>
    </section>
  );
}
